'use client';

import React, { useEffect, useRef, useState, Suspense } from 'react';
import Loading from '../Loading';
import { cn } from '@/lib/utils';
import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation';
import { AUTHORIZE_APPID, QRCONNECT_APPID } from '@/config/const';
import { publicAsset } from '@/lib/public-assets';

const redirectUri = "https://findinai.cn/redirect";

interface WeChatQRCodeLoginProps extends React.HTMLAttributes<HTMLDivElement> {
  onLoad?: () => void;
  useIframe?: boolean;
}

function WeChatQRCodeLoginContent({
  className,
  useIframe = true,
}: WeChatQRCodeLoginProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loaded, setLoaded] = useState(false);
  const searchParams = useSearchParams();

  useEffect(() => {
    const redirectParams = new URLSearchParams(searchParams.toString());
    const currentHost = `${window.location.protocol}//${window.location.host}`;
    redirectParams.set('href', encodeURIComponent(`${currentHost}${window.location.pathname}`));
    redirectParams.delete('code');
    // 构建URL
    const qrParams = new URLSearchParams({
      appid: QRCONNECT_APPID,
      scope: "snsapi_login",
      redirect_uri: `${redirectUri}?${redirectParams.toString()}`,
      response_type: "code",
      login_type: "jssdk",
      self_redirect: "false",
      state: "",
      styletype: "",
      sizetype: "",
      bgcolor: "",
      rst: "",
      href: publicAsset("/css/wechatLogin.css")
    });
    const qrConnectUrl = `https://open.weixin.qq.com/connect/qrconnect?${qrParams.toString()}`;
    // 加载iframe
    if (useIframe && iframeRef.current) {
      iframeRef.current.src = qrConnectUrl;
    } else if (!useIframe) {
      window.location.href = qrConnectUrl;
    }
  }, [searchParams, useIframe]);

  return (
    <div className={cn(
      "w-[17.5rem] h-[16.875rem] relative",
      className,
    )}>
      <iframe
        ref={iframeRef}
        title="微信扫码登录"
        width="100%"
        height="100%"
        onLoad={() => {
          setLoaded(true);
        }}
      />
      {loaded ? null : <Loading mask />}
    </div>
  );
}

export const WeChatQRCodeLogin = ({
  className,
  useIframe = true,
}: WeChatQRCodeLoginProps) => {
  return (
    <Suspense fallback={<Loading mask />}>
      <WeChatQRCodeLoginContent className={className} useIframe={useIframe} />
    </Suspense>
  );
};

export const doAuthorizeLogin = (searchParams: ReadonlyURLSearchParams) => {
  const redirectParams = new URLSearchParams(searchParams.toString());
  const currentHost = `${window.location.protocol}//${window.location.host}`;
  redirectParams.set('href', encodeURIComponent(`${currentHost}${window.location.pathname}`));
  redirectParams.delete('code');

  const authParams = new URLSearchParams({
    appid: AUTHORIZE_APPID,
    scope: 'snsapi_userinfo',
    redirect_uri: `${redirectUri}?${redirectParams.toString()}`,
    response_type: 'code',
    state: '',
  });

  const authorizeUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?${authParams.toString()}#wechat_redirect`;

  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('micromessenger')) {
    window.location.href = authorizeUrl;
  }
}
